var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSocialTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 16,
    fill: "#C0DAEC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2302_7136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 10C16.268 10 10 16.268 10 24C10 31.732 16.268 38 24 38C31.732 38 38 31.732 38 24C38 16.268 31.732 10 24 10Z",
    fill: "#40B3E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8122 18.0532L28.3117 30.6605C28.3117 30.6605 27.962 31.5348 27.0003 31.1152L21.2299 26.6912L19.1316 25.677L15.5995 24.4879C15.5995 24.4879 15.0574 24.2956 15.0049 23.876C14.9525 23.4563 15.617 23.229 15.617 23.229L29.6581 17.7209C29.6581 17.7209 30.8122 17.2138 30.8122 18.0532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7866 30.519C20.7866 30.519 20.6181 30.5032 20.4082 29.8387C20.1985 29.1742 19.1318 25.6771 19.1318 25.6771L27.6124 20.2914C27.6124 20.2914 28.1021 19.9941 28.0846 20.2914C28.0846 20.2914 28.172 20.3438 27.9097 20.5886C27.6474 20.8335 21.2476 26.5863 21.2476 26.5863",
    fill: "#D2E5F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4422 28.3875L21.1598 30.4685C21.1598 30.4685 20.9814 30.6039 20.7861 30.519L21.2232 26.6536",
    fill: "#B5CFE4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2302_7136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocialTelegram);
export default __webpack_public_path__ + "static/media/icon-social-telegram.ffb44a41631feda407c30d99d7d4d0c5.svg";
export { ForwardRef as ReactComponent };